// When a share link is opened while signed out, stash the token here so the
// sign-in screen can resume the redeem once authentication succeeds. In-memory
// is enough: a cold-start deep link re-routes to the same screen after sign-in.

export type PendingJoin = { token: string };

let pending: PendingJoin | null = null;

export function setPendingJoin(value: PendingJoin): void {
  pending = value;
}

/**
 * Read the pending join without clearing it. The sign-in and sign-up screens can
 * be mounted simultaneously on web (pushing /sign-up leaves /sign-in in the
 * stack), so both must resolve the *same* post-auth destination — a one-shot read
 * would let one screen consume the token and the other redirect home, dropping
 * the join. The consumer (JoinScreen) clears it once the redeem is under way.
 */
export function peekPendingJoin(): PendingJoin | null {
  return pending;
}

/** Read and clear the pending join (one-shot). */
export function takePendingJoin(): PendingJoin | null {
  const value = pending;
  pending = null;
  return value;
}
